<template>
	<div class="stuck-notice">
		<WarningAlt20 class="stuck-notice-icon" />
		<span class="stuck-notice-text sgnl-text-color-warning sgnl-paragraph-s-regular">{{ message }}</span>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import WarningAlt20 from "@carbon/icons-vue/es/warning--alt/20";

export default defineComponent({
	name: "StuckNotice",
	components: { WarningAlt20 },
	props: {
		message: { type: String, required: true },
	},
});
</script>

<style scoped>
.stuck-notice {
	display: flex;
	align-items: center;
	gap: var(--sgnl-space-8);
}

.stuck-notice-icon {
	color: var(--sgnl-alert-warning-icon);
	flex-shrink: 0;
}
</style>
